import React, { useState, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout, updateProfile } from '../../store/actions/authActions';
import { changePassword } from '../../api/backend';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/gattomioNero.png';

const AccountPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(state => state.auth);

  const [activeTab, setActiveTab] = useState('profile');

  // Form profilo
  const [profileData, setProfileData] = useState({
    name: user?.name || '',
    phone: user?.phone || '',
    address: user?.address || '',
    city: user?.city || '',
    zip: user?.zip || '',
    country: user?.country || 'IT',
  });
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileSuccess, setProfileSuccess] = useState(false);
  const [profileError, setProfileError] = useState(null);

  // Form password
  const [passwordData, setPasswordData] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
  });
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [passwordError, setPasswordError] = useState(null);

  const handleProfileChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
    setProfileSuccess(false);
    setProfileError(null);
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      setProfileLoading(true);
      setProfileError(null);
      await dispatch(updateProfile(profileData));
      setProfileSuccess(true);
    } catch (err) {
      setProfileError('Errore durante il salvataggio del profilo');
    } finally {
      setProfileLoading(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
    setPasswordSuccess(false);
    setPasswordError(null);
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.new_password !== passwordData.new_password_confirmation) {
      setPasswordError('Le nuove password non coincidono');
      return;
    }
    if (passwordData.new_password.length < 8) {
      setPasswordError('La nuova password deve essere almeno 8 caratteri');
      return;
    }
    try {
      setPasswordLoading(true);
      setPasswordError(null);
      await changePassword(passwordData);
      setPasswordSuccess(true);
      setPasswordData({ current_password: '', new_password: '', new_password_confirmation: '' });
    } catch (err) {
      setPasswordError(err?.current_password?.[0] || 'Errore durante il cambio password');
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleLogout = async () => {
    await dispatch(logout());
    navigate('/');
  };

  return (
    <Fragment>
      <Navbar hclass={'wpo-site-header'} Logo={Logo} />
      <PageTitle pageTitle={'Il mio account'} pagesub={'Account'} />
      <section className="wpo-account-section section-padding">
        <div className="container">
          <div className="account-wrapper">

            {/* Sidebar */}
            <div className="account-sidebar">
              <div className="sidebar-card">
                <div className="sidebar-header">
                  <div className="user-avatar">
                    {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                  </div>
                  <div className="user-name">{user?.name}</div>
                  <div className="user-email">{user?.email}</div>
                </div>
                <ul className="sidebar-menu">
                  <li className="menu-item">
                    <button
                      onClick={() => setActiveTab('profile')}
                      className={activeTab === 'profile' ? 'active' : ''}
                    >
                      <i className="ti-user"></i> Profilo
                    </button>
                  </li>
                  <li className="menu-item">
                    <button
                      onClick={() => setActiveTab('password')}
                      className={activeTab === 'password' ? 'active' : ''}
                    >
                      <i className="ti-lock"></i> Password
                    </button>
                  </li>
                  <li className="menu-item">
                    <Link to="/orders">
                      <i className="ti-bag"></i> I miei ordini
                    </Link>
                  </li>
                  <li className="menu-item">
                    <button
                      onClick={handleLogout}
                      className="logout"
                    >
                      <i className="ti-power-off"></i> Esci
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contenuto */}
            <div className="account-content">

              {/* Tab Profilo */}
              {activeTab === 'profile' && (
                <div className="content-card">
                  <div className="card-header">
                    <h3>Modifica profilo</h3>
                  </div>
                  <div className="card-body">
                    {profileSuccess && (
                      <div className="account-alert alert-success">
                        <i className="ti-check"></i>
                        <p>Profilo aggiornato con successo!</p>
                      </div>
                    )}
                    {profileError && (
                      <div className="account-alert alert-danger">
                        <i className="ti-alert"></i>
                        <p>{profileError}</p>
                      </div>
                    )}
                    <form onSubmit={handleProfileSubmit} className="account-form">
                      <div className="form-row">
                        <div className="form-group">
                          <label>Nome completo</label>
                          <input
                            type="text"
                            name="name"
                            value={profileData.name}
                            onChange={handleProfileChange}
                          />
                        </div>
                        <div className="form-group">
                          <label>Telefono</label>
                          <input
                            type="tel"
                            name="phone"
                            value={profileData.phone}
                            onChange={handleProfileChange}
                            placeholder="+39 333 1234567"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Indirizzo</label>
                        <input
                          type="text"
                          name="address"
                          value={profileData.address}
                          onChange={handleProfileChange}
                          placeholder="Via Roma, 1"
                        />
                      </div>
                      <div className="form-row">
                        <div className="form-group">
                          <label>Città</label>
                          <input
                            type="text"
                            name="city"
                            value={profileData.city}
                            onChange={handleProfileChange}
                          />
                        </div>
                        <div className="form-group">
                          <label>CAP</label>
                          <input
                            type="text"
                            name="zip"
                            value={profileData.zip}
                            onChange={handleProfileChange}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Paese</label>
                        <select
                          name="country"
                          value={profileData.country}
                          onChange={handleProfileChange}
                        >
                          <option value="IT">Italia</option>
                          <option value="FR">Francia</option>
                          <option value="DE">Germania</option>
                          <option value="ES">Spagna</option>
                          <option value="CH">Svizzera</option>
                        </select>
                      </div>
                      <div className="form-button">
                        <button type="submit" disabled={profileLoading}>
                          {profileLoading ? 'Salvataggio...' : 'Salva modifiche'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {/* Tab Password */}
              {activeTab === 'password' && (
                <div className="content-card">
                  <div className="card-header">
                    <h3>Cambia password</h3>
                  </div>
                  <div className="card-body">
                    {passwordSuccess && (
                      <div className="account-alert alert-success">
                        <i className="ti-check"></i>
                        <p>Password aggiornata con successo!</p>
                      </div>
                    )}
                    {passwordError && (
                      <div className="account-alert alert-danger">
                        <i className="ti-alert"></i>
                        <p>{passwordError}</p>
                      </div>
                    )}
                    <form onSubmit={handlePasswordSubmit} className="account-form">
                      <div className="form-group">
                        <label>Password attuale</label>
                        <input
                          type="password"
                          name="current_password"
                          value={passwordData.current_password}
                          onChange={handlePasswordChange}
                          autoComplete="current-password"
                        />
                      </div>
                      <div className="form-row">
                        <div className="form-group">
                          <label>Nuova password</label>
                          <input
                            type="password"
                            name="new_password"
                            value={passwordData.new_password}
                            onChange={handlePasswordChange}
                            placeholder="Minimo 8 caratteri"
                            autoComplete="new-password"
                          />
                        </div>
                        <div className="form-group">
                          <label>Conferma nuova password</label>
                          <input
                            type="password"
                            name="new_password_confirmation"
                            value={passwordData.new_password_confirmation}
                            onChange={handlePasswordChange}
                            autoComplete="new-password"
                          />
                        </div>
                      </div>
                      <div className="form-button">
                        <button type="submit" disabled={passwordLoading}>
                          {passwordLoading ? 'Aggiornamento...' : 'Cambia password'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default AccountPage;
